import * as S from "./styles";
import { ArrowForward as IconArrowNext } from "@material-ui/icons";
import { useHistory } from "react-router";
import { Header } from "components/Header";

import choiceThePropertyImage from "../../assets/images/escolher-o-imovel.png";

export function Home() {
  const history = useHistory();

  function goToSimulator() {
    history.push("/modalidade");
  }

  return (
    <S.Container>
      <S.IntroductionContainer>
        <Header />

        <S.IntroductionWrapper>
          <div>
            <S.Title>
              Faça sua simulação online
              <br />e de forma gratuita.
            </S.Title>

            <S.CustomizedButton
              onClick={goToSimulator}
              endIcon={<IconArrowNext />}
              style={{ backgroundColor: "#00443d", height: 42, width: 194 }}
            >
              QUERO SIMULAR
            </S.CustomizedButton>
          </div>

          <S.ChoiceThePropertyImage src={choiceThePropertyImage} />
        </S.IntroductionWrapper>
      </S.IntroductionContainer>
    </S.Container>
  );
}
